import { render, staticRenderFns } from "./AnchorTabs.vue?vue&type=template&id=e3b039ca&"
import script from "./AnchorTabs.vue?vue&type=script&lang=js&"
export * from "./AnchorTabs.vue?vue&type=script&lang=js&"
import style0 from "./AnchorTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports